"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var BLE_Device = new JS.Class({

  _decode_result: function _decode_result(result, reader) {
    return new Uint8Array(result);
  },

  alternateService: function alternateService() {
    return null;
  },

  getAdvertisedName: function getAdvertisedName() {
    return this.advertised_name;
  },

  settableUnits: function settableUnits() {
    return [];
  },

  needsInitialConnect: function needsInitialConnect() {
    return false;
  },

  readingWaitTime: function readingWaitTime() {
    return mymobileConfig.readings_timeout_seconds * 1000;
  },

  serialCheckRequired: function serialCheckRequired() {
    return BLE_CONTROL.identifyDevicesBySerialNumber();
  },

  initialize: function initialize(name, model_name, device_uuid, service_uuid, measurement_uuids, options) {
    console.log("Creating new ", model_name);
    console.log("Device_UUID: ", device_uuid);

    if (!options) {
      options = {};
    }

    this.isBLE = true;
    this.preventDuplicates = false;

    this.name = name;
    this.model_name = model_name;

    //User might input uuid without colons.
    //If we are using iOS we don't want to mess with this b/c the id is not a mac address
    if (deviceOS != 'iOS' && device_uuid.search(/:/) == -1) {
      device_uuid = device_uuid.replace(/[a-z0-9]{2}/gi, '$&:');
      if (device_uuid.charAt(device_uuid.length - 1) == ':') {
        device_uuid = device_uuid.slice(0, -1);
      }
    }

    this.device_uuid = device_uuid;
    this.ble_id = device_uuid; // keep this since device_uuid field will be replaced

    this.service_uuid = service_uuid;
    this.measurement_uuids = measurement_uuids;
    this.returnsFloatValue = false;

    if (options.returnsFloatValue) {
      this.returnsFloatValue = true;
    }

    this.ignoreList = []; // devices with unmatched serial numbers - 
  },

  needsPairing: function needsPairing() {
    return false;
  },

  isSupported: function isSupported() {
    return BLE_CONTROL.has_ble;
  },

  allowManual: function allowManual() {
    return !this.collectsBinaryData;
  },

  skipReading: function skipReading(reading, readingCount) {
    return false;
  },

  waitForReadings: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(connectParams, progress) {
      var reader;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reader = this.makeReader();

              BLE_CONTROL.setActiveReader(reader);
              return _context.abrupt("return", reader.waitForReadings(connectParams, progress));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function waitForReadings(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return waitForReadings;
  }(),

  makeReader: function makeReader() {
    return new BleReader(this);
  },

  ignoreDevice: function ignoreDevice(id) {
    var ignoreThisOne = -1 != this.ignoreList.indexOf(id);

    if (ignoreThisOne) {
      console.log(" Ignoring: " + id);
    }

    return ignoreThisOne;
  },

  addToIgnoreList: function addToIgnoreList(id) {
    this.ignoreList.push(id);
  }
});